  
export const LengthMeasurement = {
    MILES: "miles",
    METERS: "meters"
}